import React from 'react';
import { Field } from 'formik';

import './radio.field.scss';

const RadioField = ({
	type, label, extraLabel, ...props
}) => (
	<label className="radio-field">
		<Field type="radio" {...props} />
		<span className="checkmark" />

		<div className="radio-description">
			<span className="radio-left-text">{label}</span>
			<span className="radio-right-text">{extraLabel}</span>
		</div>
	</label>
);

export default RadioField;
